import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { trackEvent } from '../lib/analytics';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const onHeaderWhatsApp = () => {
    trackEvent('click_whatsapp', { location: 'header' });
    window.open('https://wa.me/610487698671', '_blank');
    setIsMenuOpen(false);
  };

  const onNavClick = (id) => {
    trackEvent('click_nav_link', { section: id });
    scrollToSection(id);
  };

  const navItems = [
    { id: 'services', label: 'Services' },
    { id: 'gallery', label: 'Our Work' },
    { id: 'reviews', label: 'Reviews' },
    { id: 'quote', label: 'Get Quote' },
    { id: 'contact', label: 'Contact' },
  ];

  return (
    <header className="fixed top-0 w-full bg-white/95 backdrop-blur-sm shadow-sm z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-24">
          {/* Logo */}
          <div className="flex items-center cursor-pointer gap-2" onClick={() => scrollToSection('hero')} data-testid="brand-logo">
            <img
              src="/logo-cube.webp"
              alt="MoveMate Sydney Removals logo"
              width="80"
              height="80"
              fetchPriority="high"
              decoding="async"
              className="h-12 sm:h-20 w-auto object-contain"
            />
            <div className="leading-none">
              <div className="text-lg sm:text-3xl font-extrabold text-[#1E3A5F] tracking-tight">MOVEMATE</div>
              <div className="h-0.5 sm:h-1 bg-[#FF8C42] my-0.5 sm:my-1"></div>
              <div className="text-[10px] sm:text-sm font-bold text-[#FF8C42] tracking-widest">SYDNEY REMOVALS</div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => onNavClick('services')} className="text-[#1E3A5F] font-semibold hover:text-[#FF8C42] transition-colors">
              Services
            </button>
            <button onClick={() => onNavClick('gallery')} className="text-[#1E3A5F] font-semibold hover:text-[#FF8C42] transition-colors">
              Our Work
            </button>
            <button onClick={() => onNavClick('reviews')} className="text-[#1E3A5F] font-semibold hover:text-[#FF8C42] transition-colors">
              Reviews
            </button>
            <button onClick={() => onNavClick('quote')} className="text-[#1E3A5F] font-semibold hover:text-[#FF8C42] transition-colors">
              Get Quote
            </button>
            <button onClick={() => onNavClick('contact')} className="text-[#1E3A5F] font-semibold hover:text-[#FF8C42] transition-colors">
              Contact
            </button>
            <Button 
              className="bg-[#FF8C42] hover:bg-[#e67a35] text-white"
              onClick={onHeaderWhatsApp}
              data-testid="header-whatsapp-desktop"
            >
              <Phone className="w-4 h-4 mr-2" />
              WhatsApp
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[#1E3A5F]"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
            data-testid="mobile-menu-toggle"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu (animated slide-down + staggered items) */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
            isMenuOpen ? 'max-h-[420px] opacity-100' : 'max-h-0 opacity-0'
          }`}
          data-testid="mobile-menu"
        >
          <div className="py-4 space-y-2">
            {navItems.map((item, i) => (
              <button
                key={item.id}
                onClick={() => onNavClick(item.id)}
                style={{ transitionDelay: isMenuOpen ? `${i * 55}ms` : '0ms' }}
                className={`block w-full text-left px-4 py-2 text-[#1E3A5F] font-semibold hover:bg-gray-100 rounded-lg transition-all duration-300 ${
                  isMenuOpen ? 'translate-x-0 opacity-100' : '-translate-x-3 opacity-0'
                }`}
              >
                {item.label}
              </button>
            ))}
            <Button
              className="w-full bg-[#FF8C42] hover:bg-[#e67a35] text-white transition-all duration-300"
              style={{ transitionDelay: isMenuOpen ? `${navItems.length * 55}ms` : '0ms' }}
              onClick={onHeaderWhatsApp}
              data-testid="header-whatsapp-mobile"
            >
              <Phone className="w-4 h-4 mr-2" />
              WhatsApp
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};